// Description: Second step of the capaign add page
// Updated: 24/09/2025
// Author: Simon Franklin

// React
import React from "react";

// Material UI Components
import {
  Checkbox,
  createTheme,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  ThemeProvider,
} from "@mui/material";

// Components and functions for the project
import DynamicInput from "../../../components/CreatingCampaign/DynamicInput";

// Render The Component
const Step2 = ({ formState, error, setError, updateFieldValue }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <FormControl
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <FormLabel
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: error["Tipo de campanha"] === true ? "red" : "#000",
            fontSize: "14px",
          }}
        >
          Tipo de campanha
        </FormLabel>
        <RadioGroup
          value={formState["Tipo de campanha"]}
          onChange={(e) => {
            updateFieldValue("Tipo de campanha", e.target.value);
            if (error["Tipo de campanha"] === true) {
              setError((prev) => ({
                ...prev,
                "Tipo de campanha": false,
              }));
            }
          }}
        >
          <FormControlLabel
            value="Disparo único"
            control={<Radio />}
            label="Disparo único"
          />
          <FormControlLabel
            value="Recorrência"
            control={<Radio />}
            label="Recorrência"
          />
        </RadioGroup>
      </FormControl>

      <FormControl
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <FormLabel
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: error["Envio imediato"] === true ? "red" : "#000",
            fontSize: "14px",
          }}
        >
          Início da campanha
        </FormLabel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            opacity: formState["Tipo de campanha"] === "Recorrência" ? 0.5 : 1,
            pointerEvents:
              formState["Tipo de campanha"] === "Recorrência"
                ? "none"
                : "initial",
          }}
        >
          <Checkbox
            disabled={formState["Tipo de campanha"] === "Recorrência"}
            checked={formState["Envio imediato"] === true}
            onChange={(e) => {
              if (formState["Envio imediato"] === true) {
                updateFieldValue("Envio imediato", false);
              } else {
                updateFieldValue("Envio imediato", true);
              }
              if (error["Envio imediato"] === true) {
                setError((prev) => ({
                  ...prev,
                  "Envio imediato": false,
                }));
              }
            }}
            inputProps={{ "aria-label": "controlled" }}
          />

          <p style={{ fontSize: "16px", color: "#000" }}>
            Envio imediato ao criar a campanha
          </p>
        </div>
      </FormControl>

      <div style={{ display: "flex", gap: "12px", maxWidth: "546px" }}>
        <DynamicInput
          error={error}
          formState={formState}
          fullWidth={true}
          setError={setError}
          title={"Data de início"}
          tooltip={""}
          value={formState["Data de início"]}
          type={formState["Tipo de campanha"] === "Disparo único" &&
              formState["Envio imediato"] === true
              ? "block"
              : "date"
          }
          updateFieldValue={updateFieldValue}
        />
        <DynamicInput
          error={error}
          formState={formState}
          fullWidth={true}
          setError={setError}
          title={"Hora de início"}
          tooltip={""}
          value={formState["Hora de início"]}
          type={formState["Tipo de campanha"] === "Disparo único" &&
              formState["Envio imediato"] === true
              ? "block"
              : "time"
          }
          updateFieldValue={updateFieldValue}
        />
      </div>

      <div style={{ maxWidth: "267px" }}>
        <DynamicInput
          error={error}
          formState={formState}
          fullWidth={true}
          setError={setError}
          title={"Data de término"}
          tooltip={""}
          value={formState["Data de término"]}
          type={
            formState["Tipo de campanha"] === "Disparo único" ||
            (formState["Tipo de campanha"] === "Disparo único" &&
              formState["Envio imediato"] === true)
              ? "block"
              : "date"
          }
          updateFieldValue={updateFieldValue}
        />
      </div>
    </div>
  );
};

export default Step2;
